import Highcharts from "highcharts";
// Since Highcharts 12, modules register themselves on import
import "highcharts/modules/exporting";

// Shared by every chart of the site (LevelHistoryChart.vue, FormulaComparisonChart.vue).
Highcharts.setOptions({
  lang: {
    shortMonths: ["janv", "févr", "mars", "avril", "mai", "juin", "juill", "août", "sept", "oct", "nov", "déc"],
    weekdays: ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"],
  },
  // Highcharts 13 has its own light/dark mode, which by default ("light dark") follows the device setting: a phone in
  // dark mode drew dark charts on the light site. "inherit" follows the CSS color-scheme that Vuetify sets on :root
  // and on each .v-theme--light / .v-theme--dark element, so charts always match the site's theme.
  palette: { colorScheme: "inherit" },
});

export default Highcharts;
